__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "start-frontend";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@matillion/component-library", "26.0.2", function() { return Promise.all([__webpack_require__.e(348), __webpack_require__.e(304), __webpack_require__.e(368), __webpack_require__.e(318), __webpack_require__.e(676)]).then(function() { return function() { return __webpack_require__(81368); }; }); });
			register("@matillion/hex-react", "0.123.2", function() { return Promise.all([__webpack_require__.e(674), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(0)]).then(function() { return function() { return __webpack_require__(50674); }; }); });
			register("@matillion/hub-client", "14.39.0", function() { return Promise.all([__webpack_require__.e(348), __webpack_require__.e(304), __webpack_require__.e(249), __webpack_require__.e(564), __webpack_require__.e(318), __webpack_require__.e(619)]).then(function() { return function() { return __webpack_require__(27564); }; }); });
			register("@matillion/micro-client", "1.1.0", function() { return Promise.all([__webpack_require__.e(318), __webpack_require__.e(548)]).then(function() { return function() { return __webpack_require__(13167); }; }); });
			register("@matillion/micro-router", "2.3.0", function() { return Promise.all([__webpack_require__.e(1), __webpack_require__.e(318), __webpack_require__.e(866)]).then(function() { return function() { return __webpack_require__(82001); }; }); });
			register("react-dom", "18.3.1", function() { return Promise.all([__webpack_require__.e(950), __webpack_require__.e(318)]).then(function() { return function() { return __webpack_require__(97950); }; }); });
			register("react-router-dom", "6.26.1", function() { return Promise.all([__webpack_require__.e(245), __webpack_require__.e(318), __webpack_require__.e(676), __webpack_require__.e(222)]).then(function() { return function() { return __webpack_require__(53245); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(43).then(function() { return function() { return __webpack_require__(65043); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};